import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HighlightedText from './HighlightedText.jsx';
import styles from './AutocompleteSearchBox.scss';

class AutocompleteSuggestion extends React.Component {
  render() {
    let {
      onClick,
      focused,
      onMouseEnter,
      onMouseLeave,
      className,
      searchTerm,
      suggestion,
      ...rest
    } = this.props;

    return (
      <div
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={classnames(focused ? styles.hover : null, styles.suggestion, className)}
        {...rest}
      >
        <HighlightedText text={suggestion} highlightedText={searchTerm} />
      </div>
    );
  }
}

AutocompleteSuggestion.propTypes = {
  onClick: PropTypes.func,
  focused: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string
};

export default AutocompleteSuggestion;